import React from "react";

export default function Header({ name, image }) {
  return (
    <>
      <h1 className="page_title" role="banner" tabIndex="-1">
        {`NASA SEWP Contract Holder Info for ${name}`}
      </h1>
      <div align="center" aria-hidden="true">
        <img className="logoCH" alt="Vendor logo" border="0" src={`/images6/${image}`} />
      </div>
    </>
  );
}
